import React from 'react';

const Success = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #075E54 60%, #25D366 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Inter', 'Roboto', 'Segoe UI', Arial, sans-serif",
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '1.5rem',
          boxShadow: '0 4px 32px 0 rgba(7,94,84,0.13)',
          padding: '2.5rem 2.5rem 2rem 2.5rem',
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #25D366, #075E54 85%)',
            borderRadius: '50%',
            width: 76,
            height: 76,
            margin: '0 auto 1.3rem auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 6px 24px rgba(37, 211, 102, 0.12)'
          }}
        >
          {/* WhatsApp style check */}
          <svg width="40" height="40" fill="none" viewBox="0 0 40 40">
            <circle cx="20" cy="20" r="20" fill="#25D366" />
            <path
              d="M29.03 14.22c-0.26-0.65-1.01-1.07-2.11-1.6-1.16-0.55-2-0.87-2.22-0.97-0.45-0.19-0.86-0.28-1.25-0.28-0.39 0-0.7 0.1-0.93 0.19-0.28 0.11-0.97 0.38-1.39 1.49-0.37 0.96-0.77 2.06-0.82 2.18-0.05 0.14-0.1 0.25-0.22 0.37s-0.18 0.13-0.32 0.07c-0.13-0.06-0.78-0.29-1.49-0.93-0.54-0.49-0.97-1.09-1.12-1.26-0.16-0.19-0.27-0.22-0.46-0.13-0.18 0.09-1.03 0.79-1.17 0.97-0.14 0.18-0.28 0.28-0.18 0.66s0.51 1.65 1.67 2.69c1.2 1.08 2.41 1.42 2.8 1.47 0.39 0.05 0.62 0.02 0.83-0.11 0.22-0.14 0.71-0.7 0.86-0.91 0.17-0.24 0.39-0.21 0.62-0.13 0.23 0.08 1.48 0.7 1.79 0.83 0.31 0.13 0.51 0.2 0.75 0.12 0.24-0.08 1.05-0.43 1.21-0.84 0.16-0.41 0.42-1.53 0.48-1.63 0.06-0.1 0.05-0.22-0.01-0.34zm-7.52 4.01C16.18 19.79 14 22.15 14 25c0 3.09 2.51 5.6 5.6 5.6s5.6-2.51 5.6-5.6c0-2.45-1.63-4.51-3.78-5.26zm4.14 4.94c-0.56 1.09-1.49 1.51-2.55 1.2-1.36-0.4-2.46-1.5-2.87-2.87-0.32-1.06 0.1-1.99 1.19-2.55 2.23-1.17 5.95 1.93 4.23 4.22z"
              fill="#fff"
            />
          </svg>
        </div>
        <h2
          style={{
            color: '#075E54',
            fontWeight: 800,
            fontSize: '2.1rem',
            margin: '0 0 0.7rem 0',
            letterSpacing: '-1px',
          }}
        >
          Connected!
        </h2>
        <div
          style={{
            color: '#333',
            fontSize: '1.13rem',
            marginBottom: '1.3rem',
          }}
        >
          Your WhatsApp Account was successfully connected.<br />
          You can now use Omni channels and integrations.
        </div>
        <a
          href="https://wa.globebot.io/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            background: 'linear-gradient(90deg, #25D366 60%, #128C7E 100%)',
            color: '#fff',
            fontWeight: 700,
            border: 'none',
            outline: 'none',
            borderRadius: '2em',
            padding: '0.8em 2.1em',
            fontSize: '1.09rem',
            letterSpacing: '0.02em',
            boxShadow: '0 2px 18px 0 rgba(37,211,102,0.13)',
            textDecoration: 'none',
            transition: 'background .2s'
          }}
        >
          Go to Dashboard
        </a>
      </div>
    </div>
  );
};

export default Success;